import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import UtilsIndex from '@/features/utils/UtilsIndex'

export const Route = createFileRoute('/utils/')({
  component: SettingsComponent,
})

function SettingsComponent() {
  return <UtilsIndex />
}
